export const PAGE_VIEW_OPTION = {
  OPTION_SELECT: "Print Option",
  DETAILS_FORM: "Please Enter Your Details",
  DEDICATION_FORM: "Do you want to add a dedication page?",
};
